import { SportConstant } from '@frontend/sports/common/core/data-access/constants';

const animationIcons = {
    [SportConstant.Soccer]: true,
    [SportConstant.Basketball]: true,
    [SportConstant.Tennis]: true,
    [SportConstant.Icehockey]: true,
    [SportConstant.Golf]: true,
};

export function getAnimationIconForSport(sportId: number, active: boolean): string {
    return `sports-${animationIcons[sportId as keyof typeof animationIcons] ? sportId : SportConstant.Soccer}-match${active ? '-active' : ''}`;
}
export function getVideoIcon(active: boolean): string {
    return active ? 'sports-video-active' : 'sports-video';
}
export function getStatsIcon(active: boolean): string {
    return active ? 'sports-stats-active' : 'sports-stats';
}
export function getAdvancedStatsIcon(active: boolean): string {
    return active ? 'sports-stats-advanced active' : 'sports-stats-advanced';
}
